export enum DegreeEnum {
  certificate = 1,
  bachelor = 2,
  master = 3,
  phD = 4
}
